<template>
    <svg :class="svgClass" aria-hidden="true" :style="{ width: size, height: size }">
      <use :xlink:href="iconClassName" :fill="color" />
    </svg>
  </template>
   
  <script>
  export default {
    props: {
      iconName: {
        type: String,
        required: true
      },
      className: {
        type: String,
        default: ''
      },
      color: {
        type: String,
        default: '#409eff'
      },
      size: {
        type: String,
        default: '16px'
      }
    },
    computed: {
      iconClassName() {
        return `#${this.iconName}`;
      },
      svgClass() {
        return this.className ? `svg-icon ${this.className}` : 'svg-icon';
      }
    }
  };
  </script>
   
  <style scoped>
  .svg-icon {
    position: relative;
    fill: currentColor;
    vertical-align: -2px;
  }
  </style>